module.exports = __webpack_public_path__ + "img/l.e3af7bf1.webp";